import useAuthStore from '../store/authStore';

// Definición de permisos por rol
const PERMISOS_POR_ROL = {
  // JEFE_SELECCION: Exactamente igual a SUPERVISOR - acceso total
  JEFE_SELECCION: {
    verDashboard: true,
    verProcesos: true,
    crearProcesos: true,
    editarProcesos: true,
    eliminarProcesos: true,
    verPerfiles: true,
    crearPerfiles: true,
    editarPerfiles: true,
    eliminarPerfiles: true,
    verExamenes: true,
    crearExamenes: true,
    editarExamenes: true,
    eliminarExamenes: true,
    verUsuarios: true,
    crearUsuarios: true,
    editarUsuarios: true,
    eliminarUsuarios: true,
    asignarPostulantes: true,
    verResultados: true,
    exportarResultados: true,
    reenviarCredenciales: true,
  },
  
  // ANALISTA: Sin dashboard, puede crear pero NO eliminar, NO crea usuarios
  ANALISTA: {
    verDashboard: false,
    verProcesos: true,
    crearProcesos: true,
    editarProcesos: true,
    eliminarProcesos: false,
    verPerfiles: true,
    crearPerfiles: true,
    editarPerfiles: true,
    eliminarPerfiles: false,
    verExamenes: true,
    crearExamenes: true,
    editarExamenes: true,
    eliminarExamenes: false,
    verUsuarios: true,
    crearUsuarios: false,
    editarUsuarios: true,
    eliminarUsuarios: false,
    asignarPostulantes: true,
    verResultados: true,
    exportarResultados: true,
    reenviarCredenciales: true,
  },
  
  // RECLUTADOR: Solo vista, NO puede eliminar ni crear procesos/perfiles, SÍ asigna postulantes
  RECLUTADOR: {
    verDashboard: false,
    verProcesos: true,
    crearProcesos: false,
    editarProcesos: false,
    eliminarProcesos: false,
    verPerfiles: true,
    crearPerfiles: false,
    editarPerfiles: false,
    eliminarPerfiles: false,
    verExamenes: true,
    crearExamenes: false,
    editarExamenes: false,
    eliminarExamenes: false,
    verUsuarios: true,
    crearUsuarios: false,
    editarUsuarios: false,
    eliminarUsuarios: false,
    asignarPostulantes: true,
    verResultados: true,
    exportarResultados: true,
    reenviarCredenciales: false,
  },
  
  // SUPERVISOR mantiene permisos completos (por si acaso)
  SUPERVISOR: {
    verDashboard: true,
    verProcesos: true,
    crearProcesos: true,
    editarProcesos: true,
    eliminarProcesos: true,
    verPerfiles: true,
    crearPerfiles: true,
    editarPerfiles: true,
    eliminarPerfiles: true,
    verExamenes: true,
    crearExamenes: true,
    editarExamenes: true,
    eliminarExamenes: true,
    verUsuarios: true,
    crearUsuarios: true,
    editarUsuarios: true,
    eliminarUsuarios: true,
    asignarPostulantes: true,
    verResultados: true,
    exportarResultados: true,
    reenviarCredenciales: true,
  },
};

// Hook para obtener permisos del usuario actual
const usePermisos = () => {
  const { user } = useAuthStore();
  const rol = user?.rol || user?.role || '';
  
  // Obtener permisos del rol actual
  const permisos = PERMISOS_POR_ROL[rol] || {};
  
  // Función helper para verificar un permiso específico
  const tienePermiso = (permiso) => {
    return permisos[permiso] === true;
  };
  
  // Función para verificar múltiples permisos (AND)
  const tienePermisos = (...permisosRequeridos) => {
    return permisosRequeridos.every(p => permisos[p] === true);
  };
  
  // Función para verificar al menos uno de varios permisos (OR)
  const tieneAlgunPermiso = (...permisosRequeridos) => {
    return permisosRequeridos.some(p => permisos[p] === true);
  };
  
  // Obtener la ruta base según el rol
  const getRutaBase = () => {
    switch (rol) {
      case 'JEFE_SELECCION':
        return '/jefe-seleccion';
      case 'ANALISTA':
        return '/analista';
      case 'RECLUTADOR':
        return '/reclutador';
      case 'SUPERVISOR':
        return '/supervisor';
      case 'ADMIN':
      case 'SISTEMAS':
        return '/admin';
      case 'POSTULANTE':
        return '/postulante';
      default:
        return '/';
    }
  };
  
  // Obtener la ruta inicial después del login
  const getRutaInicial = () => {
    const base = getRutaBase();
    if (rol === 'ANALISTA' || rol === 'RECLUTADOR') {
      return `${base}/procesos`; // Sin dashboard
    }
    return `${base}/dashboard`;
  };
  
  return {
    rol,
    permisos,
    tienePermiso,
    tienePermisos,
    tieneAlgunPermiso,
    getRutaBase,
    getRutaInicial,
  };
};

export default usePermisos;
export { PERMISOS_POR_ROL };
